( function () {
	'use strict';

	function upcomingScheds ( moment ) {
		function today ( event ) {
			var format      = 'x';
			var eventDate   = moment( event.startDate ).format( format );
			var currentDate = moment( new Date() ).format( format );
			var endOfDay    = moment( new Date().setHours( 23, 59, 59, 999 ) ).format( format );

			return eventDate > currentDate && eventDate < endOfDay;
		}

		function week ( event ) {
			var format       = 'x';
			var eventDate    = moment( event.startDate ).format( format );
			var todayXformat = moment( new Date() ).format( format );
			var endOfWeek    = moment( new Date().setHours( 23, 59, 59, 999 ) ).day( 'Saturday' ).format( format );

			return eventDate > todayXformat && eventDate < endOfWeek && !today( event );
		}

		var ranges = {
			'today' : today,
			'week'  : week
		};

		return function ( events, range ) {
			if ( events ) {
				events = events.filter( ranges[ range ] );
			}
			return events;
		};
	}

	angular
		.module( 'app.schedules' )
		.filter( 'upcomingScheds', upcomingScheds );

	upcomingScheds.$inject = [ 'moment' ];
} )( );
